module.exports = __webpack_public_path__ + "img/hermelin_loader.28cecb98.svg";